import { SET_ROUTE } from '../helpers/constants/actionsConstants';

import type { SetRouteAction } from './types';

const setRoute = ({
  destinationCityName,
  destinationEntityId,
  destinationId,
  destinationName,
  originEntityId,
  originId,
  originName,
}: {
  originId: string;
  originName: string;
  destinationId: string;
  destinationName: string;
  destinationCityName: string;
  destinationEntityId: string;
  originEntityId: string;
}): SetRouteAction => ({
  type: SET_ROUTE,
  payload: {
    originId,
    originName,
    destinationId,
    destinationName,
    destinationCityName,
    destinationEntityId,
    originEntityId,
  },
});

export default setRoute;
